// ============================================================
// HOOKED ENGINE — SPRITE MANIFEST      [Tier 2 harvest: shape]
// Every player, boat, and fish sprite URL, defined once.
// All zones import from here. Add a new frame? Add it here.
//
// THE RESOLVER LAW (from Terror's one-art-source doctrine):
//   Unknown fish ids derive on the fly as `${CDN}/fish_${id}.webp`.
//   Drop art on the CDN → it appears everywhere, zero code change.
//   Until then the url 404s and renderers glyph-fallback.
// ============================================================

import { CDN } from "./CDN";

// ── Angler sprites (on foot) ─────────────────────────────────
export const PLAYER_SPRITES = {
  player_f_down_a:  `${CDN}/player_f_down_a.webp`,
  player_f_up_a:    `${CDN}/player_f_up_a.webp`,
  player_f_left_a:  `${CDN}/player_f_left_a.webp`,
  player_f_right_a: `${CDN}/player_f_right_a.webp`,
  player_f_idle_a:  `${CDN}/player_f_idle_a.webp`,
  player_f_idle_b:  `${CDN}/player_f_idle_b.webp`,
  player_f_cast_a:  `${CDN}/player_f_cast_a.webp`,   // rod back
  player_f_cast_b:  `${CDN}/player_f_cast_b.webp`,   // rod forward
  player_f_reel_a:  `${CDN}/player_f_reel_a.webp`,   // reel crank 1
  player_f_reel_b:  `${CDN}/player_f_reel_b.webp`,   // reel crank 2
  player_f_default: `${CDN}/player_f_idle_a.webp`,

  player_m_down_a:  `${CDN}/player_m_down_a.webp`,
  player_m_up_a:    `${CDN}/player_m_up_a.webp`,
  player_m_left_a:  `${CDN}/player_m_left_a.webp`,
  player_m_right_a: `${CDN}/player_m_right_a.webp`,
  player_m_idle_a:  `${CDN}/player_m_idle_a.webp`,
  player_m_idle_b:  `${CDN}/player_m_idle_a.webp`,
  player_m_cast_a:  `${CDN}/player_m_cast_a.webp`,
  player_m_cast_b:  `${CDN}/player_m_cast_b.webp`,
  player_m_reel_a:  `${CDN}/player_m_reel_a.webp`,
  player_m_reel_b:  `${CDN}/player_m_reel_b.webp`,
  player_m_default: `${CDN}/player_m_idle_a.webp`,
};

// ── Boat sprites (on water) ──────────────────────────────────
export const BOAT_SPRITES = {
  boat_down:  `${CDN}/boat_down.webp`,
  boat_up:    `${CDN}/boat_up.webp`,
  boat_left:  `${CDN}/boat_left.webp`,
  boat_right: `${CDN}/boat_right.webp`,
};

// ── Zone backgrounds ─────────────────────────────────────────
export const ZONE_BACKGROUNDS = {
  lake: `${CDN}/z_lake.webp`,
};

// ── Explicit fish art overrides (resolver handles the rest) ──
export const FISH_SPRITES = {
  // intentionally empty — every fish derives from fishUrl(id)
};

// ── Helpers ──────────────────────────────────────────────────

export function getPlayerSprite(gender, facingX, facingY, walkFrame) {
  const g = gender === "f" ? "f" : "m";
  let dir = "down";
  if (facingY === -1)      dir = "up";
  else if (facingY === 1)  dir = "down";
  else if (facingX === -1) dir = "left";
  else if (facingX === 1)  dir = "right";
  return (
    PLAYER_SPRITES[`player_${g}_${dir}_a`] ||
    PLAYER_SPRITES[`player_${g}_default`]
  );
}

export function getIdleSprite(gender, idleFrame) {
  const g = gender === "f" ? "f" : "m";
  return (
    PLAYER_SPRITES[`player_${g}_idle_${g === "f" && idleFrame ? "b" : "a"}`] ||
    PLAYER_SPRITES[`player_${g}_default`]
  );
}

/** Rod-action sprite: "cast" | "reel", frame boolean alternates. */
export function getActionSprite(gender, action, frame) {
  const g = gender === "f" ? "f" : "m";
  return (
    PLAYER_SPRITES[`player_${g}_${action}_${frame ? "b" : "a"}`] ||
    PLAYER_SPRITES[`player_${g}_default`]
  );
}

export function getBoatSprite(facingX, facingY) {
  let dir = "down";
  if (facingY === -1)      dir = "up";
  else if (facingY === 1)  dir = "down";
  else if (facingX === -1) dir = "left";
  else if (facingX === 1)  dir = "right";
  return BOAT_SPRITES[`boat_${dir}`];
}

/** Fish art by id — resolver pattern. Never returns null. */
export function getFishSprite(fishId) {
  if (FISH_SPRITES[fishId]) return FISH_SPRITES[fishId];
  return `${CDN}/fish_${fishId}.webp`;
}
